// store.js
import { configureStore } from '@reduxjs/toolkit';
import influencerReducer from '../Redux/user_information'; 

export const store = configureStore({
  reducer: {
    influencer: influencerReducer, 
  },
});